import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { RedirectNoticeService } from "../services/redirect-notice.service";
import { catchError, EMPTY, throwError, timeout, TimeoutError } from "rxjs";
import { StateService } from "../services/state.service";
import { ToastrService } from "ngx-toastr";
import { inject } from "@angular/core";
import { BookingType } from "../models/enums/booking-type.enum";

const REDIRECT_DELAY_MS = 4500;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const redirectNoticeService = inject(RedirectNoticeService);
  const toastrService = inject(ToastrService);
  const stateService = inject(StateService);

  const postalCode = stateService.customer().postalCode;
  const postalCodeUrl = postalCode ? '?zip=' + postalCode : ''
  const REDIRECT_URL = 'https://www.mockfjards.se/fonsterbyte-kontakta-oss/' + postalCodeUrl;

  const handleError = (message: string) => {
    if (stateService.booking().bookingType === BookingType.NewOpportunityCustomer) {
      redirectNoticeService.showAndRedirect(REDIRECT_URL, REDIRECT_DELAY_MS, message);
      return EMPTY;
    }

    toastrService.error(message, 'Fel');
    return EMPTY;
  };

  const handleErrorAndRethrow = (message: string, err: unknown) => {
    toastrService.error(message, 'Fel');
    return throwError(() => err);
  };

  return next(req).pipe(
    timeout(15_000),
    catchError((err) => {
      if (stateService.booking().bookingType === BookingType.NewOpportunityCustomer) {
        if (err instanceof TimeoutError) {
          return handleError('Det tog for lang tid att hamta svaret.');
        }

        if (err instanceof HttpErrorResponse && err.status === 0) {
          return handleError('Anslutningen till tjansten misslyckades.');
        }

        if (err instanceof HttpErrorResponse && err.status >= 500) {
          return handleError('Ett ovantat fel uppstod.');
        }

        throw err;
      }

      if (err instanceof TimeoutError) {
        return handleErrorAndRethrow('Det tog for lang tid att hamta svaret.', err);
      }

      throw err;
    })
  );
};
